// extracted by mini-css-extract-plugin
export default {"about":"product-about__about__N0BXR","whatWeLoveLarge":"product-about__whatWeLoveLarge__W7aRt","heart":"product-about__heart__OrdN_"};